module.exports = __webpack_public_path__ + "img/icon_cat_widget.1156178.png";